import React from 'react';
import {
  ComposedChart,
  Line,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import './Chart.css';

const RevenueChart: React.FC = () => {
  // Sample data for revenue chart
  const data = [
    { name: 'Mon', revenue: 4000, refunds: 500 },
    { name: 'Tue', revenue: 5500, refunds: 600 },
    { name: 'Wed', revenue: 6000, refunds: 700 },
    { name: 'Thu', revenue: 7500, refunds: 800 },
    { name: 'Fri', revenue: 8000, refunds: 900 },
    { name: 'Sat', revenue: 9000, refunds: 1000 },
    { name: 'Sun', revenue: 8500, refunds: 950 },
  ];

  return (
    <div className="chart-card">
      <div className="chart-header">
        <div>
          <h3 className="chart-title">Revenue Overview</h3>
          <p className="chart-subtitle">Net revenue vs refunds over time</p>
        </div>
        <button className="chart-export-btn">
          <span>📥</span> Export
        </button>
      </div>
      <div className="chart-content">
        <ResponsiveContainer width="100%" height={300}>
          <ComposedChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
            <XAxis dataKey="name" stroke="#666" />
            <YAxis stroke="#666" domain={[2500, 10000]} />
            <Tooltip />
            <Area
              type="monotone"
              dataKey="refunds"
              stroke="#ff6b6b"
              fill="#ff6b6b"
              fillOpacity={0.3}
            />
            <Line
              type="monotone"
              dataKey="revenue"
              stroke="#4ecdc4"
              strokeWidth={2}
              dot={{ fill: '#4ecdc4', r: 4 }}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RevenueChart;

